import { useEffect, useState } from 'react';
import { usePostMessage, useReceiveMessage } from '../../../context/messageContext';
import LandoltC from '../../../components/VisualFieldForthValley/LandoltC';
import { Button, SessionActions, StatusPill, colors } from '../../../ui';
import { StepBody, Label } from '../testScreenKit';

// Stroke Suite step 2 - Landolt C familiarisation.

const FamiliarisationPhase = ({ updateStep }) => {
  const postMessage = usePostMessage();
  const messageFromPatient = useReceiveMessage();
  const [testStatus, setTestStatus] = useState(null);
  const [potentialOpenings, setPotentialOpenings] = useState([1, 2, 3, 4]);
  const [patientResponse, setPatientResponse] = useState('--');
  const [landoltCOpeningQuadrant, setLandoltCOpeningQuadrant] = useState(0);

  const getNextOpening = () => {
    if (potentialOpenings.length === 1) {
      setTestStatus('complete');
    } else setTestStatus('active');

    setPatientResponse('--');

    const randomIndex = Math.floor(Math.random() * potentialOpenings.length);

    setLandoltCOpeningQuadrant(potentialOpenings[randomIndex]);
    setPotentialOpenings((openings) => {
      openings.splice(randomIndex, 1);
      return [...openings];
    });
  };

  useEffect(() => {
    postMessage({ type: 'LandoltCOpeningUpdate', content: landoltCOpeningQuadrant });
  }, [landoltCOpeningQuadrant, postMessage]);

  useEffect(() => {
    if (messageFromPatient.type === 'patientQuadrantResponse') {
      setPatientResponse(messageFromPatient.content);
    }
  }, [messageFromPatient]);

  const getResponseTone = () => {
    if (patientResponse === '--') return 'neutral';
    const correctResponse = landoltCOpeningQuadrant === patientResponse;
    return correctResponse ? 'success' : 'error';
  };

  return (
    <StepBody gap={16} data-testid='neuro-familiarisation'>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
        <Label size={15}>Patient Response:</Label>
        <StatusPill tone={getResponseTone()} style={{ fontSize: 15, minWidth: 40, justifyContent: 'center' }} data-testid='neuro-response'>
          {patientResponse}
        </StatusPill>
      </div>
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, minHeight: 200, width: 'min(100%, 550px)', alignSelf: 'center', color: colors.slate[800] }}>
        <LandoltC opticianView openingQuadrant={landoltCOpeningQuadrant} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button variant='success' size='lg' onClick={() => getNextOpening()} disabled={testStatus === 'complete'}>
          {`${testStatus === 'active' ? 'Next' : 'Show'} Opening`}
        </Button>
      </div>
      <SessionActions onBack={() => updateStep('eyeMotility')} primary={{ label: 'Next', onClick: () => updateStep('neuroSuiteTest') }} />
    </StepBody>
  );
};

export default FamiliarisationPhase;
